import loadable from "@loadable/component";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { Permissions } from "data/permissons";
import PageWithPermission from "components/PageWithPermission";
import Subscription from "pages/Subscription";
import Ondemand from "pages/Ondemand";
import NotificationUsers from "pages/settings/preferences/notification-user-selection";
import NotificationsSingleUser from "pages/settings/preferences/notification-preferences-setup";
import AttendancePreferences from "pages/settings/attendance/attendancePreferences";
import AdminLog from "pages/settings/attendance/adminLog";
import EmployeeAttendanceReport from "pages/reports/employee-attendance-report";
import CommunicationDetails from "pages/settings/organization/communication-preference";
import ApplyDsc from "pages/register/apply-dsc";
import AddApplyDsc from "pages/register/add-applyDsc";
import PathWithPermission from "components/PathWithPermission";
import IncomeTaxReturns from "pages/atom-pro/income-tax-returns";
import IncomeTaxForms from "pages/atom-pro/income-tax-forms";
import IncomeTaxEProceedings from "pages/atom-pro/income-tax-eproceedings";
import IncomeTaxOrder from "pages/atom-pro/income-tax-order";
import FormFullView from "views/atom-pro/formFullView";
import ClientFullView from "views/atom-pro/clientFullView";
import ClientIncomeTaxView from "views/atom-pro/ClientIncomeTaxView";
// import ClientForm from "views/atom-pro/clientForm";
import ReturnFullView from "views/atom-pro/ReturnFullView";
import ClientIncometaxReturns from "views/atom-pro/clientReturns";
import OutstandingDemandView from "views/atom-pro/OutstandingDemandView";
import ClientDemand from "views/atom-pro/clientDemand";
import ClientQuantumDocumets from "pages/client-view/quantum-check";
import EproceedingView from "views/atom-pro/EproceedingView";
import FYANoticeView from "views/atom-pro/FYANoticeView";
import FYINoticeView from "views/atom-pro/FYINoticeView";
import EproceedingFyiView from "views/atom-pro/EproceedingFyiView";
import ClientProceeding from "views/atom-pro/clientProceeding";
import OtpForgot from "views/login/OtpForgot";
import ClientIncomeTaxActivityLog from "views/atom-pro/clientActivityLog";
import IncomeTaxReports from "pages/atom-pro/reports";
import NewUpdates from "pages/atom-pro/new-updates";
import UpdatesFullVIew from "views/atom-pro/NewUpdates/ItemFullView";
import ApprovalBulkActivity from "pages/settings/bulk-activity/approval-bulk-activity";
import RecurringProfileBulkActivity from "pages/settings/bulk-activity/recurring-profile-bulk-activity";
import AttendanceBulkActivity from "pages/settings/bulk-activity/attendance-bulk-activity";
import DeletedClientGroups from "pages/settings/deleted-client-groups";
import OneDriveAuth from "pages/onedrive-auth";
import TaskPreferences from "pages/settings/preferences/task-preferences";
import PreferencesLayout from "pages/settings/preferences/layout";
import LogHourPreferences from "pages/settings/preferences/logHourPreferences";
import ClientsGroup from "pages/clients-group";
import ViewProfile from "pages/client-view/edit-permissions";
import EmailTemplateEdit from "pages/communication/templates/email/email-template-edit";
import BroadcastMessageDetails from "pages/communication/broadcast/broadcast-message-details";
import EmployeeAttendanceandTimesheetReport from "pages/reports/employee-attendance-and-timesheet-report";
import AttachmentAI from "pages/atom-pro/AI-page";
import GstrTaskView from "views/tasks/board/gstrView";
import GstrTaskIndex from "views/tasks/board/gstrTaskIndex";
import Conversation from "pages/conversation/conversation"
import WhatsAppTemplateCreator from "pages/conversation/create-template";
import Templates from "pages/communication/templates";
import WhatsappTemplates from "pages/conversation/templates";
import NonRecurringBulkEdit from "pages/settings/bulk-activity/non-recurring-profile-bulk-activity";
import TasksBulkImport from "pages/settings/bulk-activity/tasks-bulk-import";
import NotificationNotify from "views/sendReminders/notificationNotify";
import OrganizationPreference from "pages/settings/preferences/org-preference-setup";
import DeletedClientClientGroup from "pages/settings/deleted-client-cg";
import DeletedPanTanGst from "pages/settings/deleted-pan-tan-gst";
import ReminderSent from "pages/settings/reminders-sent";
import ReminderDetails from "pages/settings/reminder-sent-details";
import McaFillingStatus from "pages/atom-pro/Mca/mcaServices/fillingStatus";
import McaCompanyDetails from "pages/atom-pro/Mca/mcaServices/companyOrLlp";
import McaMasterData from "pages/atom-pro/Mca/mcaServices/masterData";
import McaServices from "pages/atom-pro/Mca/mcaServices";
import McaClients from "pages/atom-pro/Mca/clients";
import McaDashboard from "pages/atom-pro/Mca/dashboard";
import McaLateFeeCalculator from "pages/atom-pro/Mca/lateFeeCalculator";
import ViderConnect from "pages/vider-connect/vider-connect";
import ChatWindow from "views/vider-connect/chat-window";
import TimesheetFiledVsNotFiledFullView from "views/dashboard/OrgDashboard/employee-time-sheet-Full-View";
import TaskStatusByClientNavigate from "views/dashboard/OrgDashboard/loghour-analytics/TaskStatusByClientNavigate";
import GstReports from "pages/atom-pro/Gst/gstReports";
import GstReturnReports from "pages/atom-pro/Gst/gstReturnReports";
import GstReportsFullView from "views/atom-pro/Gstr/Fullview/gstReportsFullView";
import Cateogries from "pages/settings/cateogries";
import IncomeTaxDsc from "pages/atom-pro/income-tax-dsc";
import IncomeTaxBankAccDeatils from "pages/atom-pro/income-tax-bank-acc-details";
import ExpiryMgmt from "pages/register/expire-mgmt";
import UnbilledTasks from "pages/billing/unbilled-tasks";
import BillingEntitiesServiceDescription from "pages/settings/organization/entities-services";
import KnowledgeBase from "../pages/atom-pro/Knowledge-base";
import GstReceivable from "pages/billing/gst-receivable";

const CreateTask = loadable(() => import("views/tasks/board/CreateTask"));
const Planner = loadable(() => import("pages/planner"));
const Calendar = loadable(() => import("pages/calendar"));
const Billing = loadable(() => import("pages/billing"));
const BillingClients = loadable(() => import("pages/billing/clients"));
const Billingclientview = loadable(() => import("pages/billing/clients/billingclientview"));
const Billingclientoverview = loadable(() => import("pages/billing/clients/billingclientoverview"));
const Invoices = loadable(() => import("pages/billing/invoices"));
const CreditNotes = loadable(() => import("pages/billing/credit-note"));
const Proforma = loadable(() => import("pages/billing/proforma"));
const BillingDashboard = loadable(() => import("pages/billing/Dashboard"));
const AddInvoice = loadable(() => import("pages/billing/invoices/add-invoice"));
const AddInvoiceReceipt = loadable(() => import("pages/billing/invoices/create-receipt"));
const EditInvoiceReceipt = loadable(() => import("pages/billing/invoices/edit-receipt"));
const EditInvoice = loadable(() => import("pages/billing/invoices/edit-invoice"));
const InvoicePreview = loadable(() => import("pages/billing/invoices/preview-invoice"));
const AddCreditNote = loadable(() => import("pages/billing/credit-note/add-credit-note"));
const EditCreditNote = loadable(() => import("pages/billing/credit-note/edit-credit-note"));
const CreditNotePreview = loadable(() => import("pages/billing/credit-note/preview-credit-note"));
//Proforma Invoice
const AddProforma = loadable(() => import("pages/billing/proforma/add-proforma"));
const EditProforma = loadable(() => import("pages/billing/proforma/edit-proforma"));
const ProformaPreview = loadable(() => import("pages/billing/proforma/proforma-preview"));
const ConvertInvoice = loadable(() => import("pages/billing/proforma/convert-proforma"));

const Receipts = loadable(() => import("pages/billing/receipts"));
const ReceiptPreview = loadable(() => import("pages/billing/receipts/receipt-preview"));
const AddReceipt = loadable(() => import("pages/billing/receipts/add-receipt"));
const EditReceipt = loadable(() => import("pages/billing/receipts/edit-receipt"));
const Expenditure = loadable(() => import("pages/billing/Expenditure"));
const Gst = loadable(() => import("pages/billing/Gst"));
const Tds = loadable(() => import("pages/billing/Tds"));
const DeletedClients = loadable(() => import("pages/settings/deleted-clients"));
const DeletedTerminatedTasks = loadable(() => import("pages/settings/deleted-terminated-tasks"));
const CompletedTasks = loadable(() => import("pages/settings/completed-tasks"));
const UpcomingTasks = loadable(() => import("pages/settings/upcoming-tasks"));
const DeletedUsers = loadable(() => import("pages/settings/deleted-users"));
const DeletedLeads = loadable(() => import("pages/settings/deleted-leads"));
const DeletedIncomeTaxClients = loadable(() => import("pages/settings/deleted-incometax"));
const DeletedGstrClients = loadable(() => import("pages/settings/deleted-gstr"));
const Login = loadable(() => import("pages/login"));
const MfaAuthentication = loadable(() => import("pages/authentication"));
const SsoLanding = loadable(() => import("pages/sso"));
const CollectData = loadable(() => import("pages/collect-data"));
// Public proposal page a lead opens from their email / WhatsApp link (OTP instead of login)
const LeadPortal = loadable(() => import("pages/leadPortal"));
const ResetPassword = loadable(() => import("pages/reset-password"));
const Join = loadable(() => import("pages/join"));
const SignUp = loadable(() => import("pages/signup"));
const Layout = loadable(() => import("layout/primarylayout"));
const SettingsLayout = loadable(() => import("layout/settingslayout"));
const TaskBoard = loadable(() => import("pages/tasks"));
const BillingEntities = loadable(() => import("pages/settings/organization/billing-entities"));
const BillingEntityProfile = loadable(
  () => import("pages/settings/organization/billing-entity-profile")
);
const OrgChart = loadable(() => import("pages/settings/org-chats/orgChart"));

const MyProfile = loadable(() => import("pages/settings/profile"));
const SendNotifications = loadable(() => import("pages/settings/sendNotifications"));
const Labels = loadable(() => import("pages/settings/labels"));

const Users = loadable(() => import("pages/settings/manage-users/users"));
const InviteUsers = loadable(() => import("pages/settings/manage-users/invited-users"));
const UserAvailabilty = loadable(() => import("pages/settings/manage-users/user-availability"));
const ViewUser = loadable(() => import("pages/settings/manage-users/users/view-user"));
const Teams = loadable(() => import("pages/settings/manage-users/teams"));
const ViewTeam = loadable(() => import("pages/settings/manage-users/teams/view-team"));
const NotificationsPreferences = loadable(() => import("pages/settings/notifications-preferences"));
const ClientNotificationPreferences = loadable(() => import("pages/settings/client-preferences"));
const OrganizationPreferences = loadable(() => import("pages/settings/preferences/org-preference"));
const ClientLayout = loadable(() => import("pages/settings/client-preferences/layout"));
const ClientPrefix = loadable(() => import("pages/settings/client-preferences/client-prefix"));
const ClientWhatsappNumber = loadable(() => import("pages/settings/client-preferences/whatsapp-number"));

const Clients = loadable(() => import("pages/clients"));
const Leads = loadable(() => import("pages/leads"));
const LeadView = loadable(() => import("pages/leads/view"));
const LeadDocumentTemplates = loadable(() => import("pages/leadDocumentTemplates"));
const LeadDocumentTemplateEditor = loadable(() => import("pages/leadDocumentTemplates/TemplateEditorPage"));
const LeadDocumentTemplatePreview = loadable(() => import("pages/leadDocumentTemplates/TemplatePreviewPage"));
const LeadDocumentEditor = loadable(() => import("pages/leads/documents/LeadDocumentEditorPage"));
const LeadDocumentPreview = loadable(() => import("pages/leads/documents/LeadDocumentPreviewPage"));
const DscRegister = loadable(() => import("pages/register/dsc-register"));
const ClientDscRegister = loadable(() => import("pages/client-view/dsc-register"));
const ClientDscRegisterView = loadable(() => import("pages/client-view/view-dsc-register"));
const GstUi = loadable(() => import("pages/register/gst-returns"));
const GstRegular = loadable(() => import("views/register/GstReturns/Regular"));
const GstCollector = loadable(() => import("views/register/GstReturns/Collector"));
const GstDeductor = loadable(() => import("views/register/GstReturns/Deductor"));
const GstDistributor = loadable(() => import("views/register/GstReturns/Distributor"));
const GstrClients = loadable(() => import("pages/atom-pro/Gst/clients"));
const AdditionalOrdersAndNotices = loadable(
  () => import("pages/atom-pro/Gst/additionalOrdersAndNotices")
);
const NoticesAndOrders = loadable(() => import("pages/atom-pro/Gst/NoticeAndOrders"));
const GstrReports = loadable(() => import("pages/atom-pro/Gst/reports"));
const AdditionalRecordsView = loadable(
  () => import("views/atom-pro/Gstr/Fullview/additionalRecordView")
);
const NoticeAndOrderView = loadable(
  () => import("views/atom-pro/Gstr/Fullview/noticeAndOrderView")
);
const GstrView = loadable(() => import("views/atom-pro/Gstr/modules/gstrView"));
const GstrProfile = loadable(() => import("views/atom-pro/Gstr/modules/profile"));
const AdditionalNotice = loadable(() => import("views/atom-pro/Gstr/modules/gstrAdditionalNotice"));
const NoticeAndOrders = loadable(() => import("views/atom-pro/Gstr/modules/noticeAndOrders"));
const GstrCompliance = loadable(() => import("views/atom-pro/Gstr/modules/gstrCompliance"));
const NoticeAndOrderFullView = loadable(
  () => import("views/atom-pro/Gstr/Fullview/noticeAndOrderFullView")
);
const AdditonalNoticeFullView = loadable(
  () => import("views/atom-pro/Gstr/Fullview/additonalNoticeFullView")
);
const ClientGstrActivityLog = loadable(
  () => import("views/atom-pro/Gstr/gstr-client/clientActivityLog")
);
const ClientSyncStatus = loadable(() => import("views/atom-pro/Gstr/gstr-client/clientSyncStatus"));
const GstrCalendar = loadable(() => import("pages/atom-pro/Gst/Calendar"));
const NewGstrUpdates = loadable(() => import("pages/atom-pro/Gst/new-updates"));
const UpdatesGstrFullView = loadable(() => import("views/atom-pro/Gstr/NewUpdates/ItemFullView"));
const ClientGstrActivity = loadable(() => import("views/atom-pro/Gstr/gstr-client/clientActivity"));

const GstrDashboard = loadable(() => import("pages/atom-pro/Gst/gstr-dashboard"));

const UdinRegister = loadable(() => import("pages/register/udin-register"));
const IcaiSspRegister = loadable(() => import("pages/register/icai-ssp"));
const DocumentInOut = loadable(() => import("pages/register/document/document-in-out"));

const ClientView = loadable(() => import("pages/client-view"));
const TasksView = loadable(() => import("pages/task-view"));
const Attachments = loadable(() => import("pages/client-view/attachments"));
const KybInfo = loadable(() => import("pages/client-view/kyb-info"));
const ImportData = loadable(() => import("pages/client-view/import-data"));
const Credentials = loadable(() => import("pages/client-view/credentials"));
const Archives = loadable(() => import("pages/client-view/archives"));
const Tasks = loadable(() => import("pages/client-view/clientTasks"));
const ClientActivityLog = loadable(() => import("pages/client-view/client-activitylog"));
const ProfileDetails = loadable(() => import("pages/client-view/profile"));
const GroupProfileDetails = loadable(() => import("pages/client-view/group-profile"));
const GstReturns = loadable(() => import("pages/client-view/compliance"));
const UpComingTasks = loadable(() => import("pages/client-view/upcoming-tasks"));
const ClientQuantumDocuments = loadable(() => import("pages/client-view/client-qtm-documents"));
const ClientIncomeTaxActivity = loadable(() => import("views/atom-pro/clientActivity"));

const OrganizationProfile = loadable(
  () => import("pages/settings/organization/organization-profile")
);

const OrganizationOnboarding = loadable(
  () => import("pages/settings/organization/onboarding")
);

const RecurringProfile = loadable(() => {
  return import("pages/client-view/recurring-profile");
});

// Dashboard
const Dashboard = loadable(() => import("pages/dashboard"));
const TasksByService = loadable(() => import("pages/dashboard/tasks-by-service"));
const ClientByCategory = loadable(() => import("pages/dashboard/client-by-category"));
const ClientCategory = loadable(() => import("pages/dashboard/client-categories"));
const ServiceCategory = loadable(() => import("pages/dashboard/service-categories"));
const OverDueTasks = loadable(() => import("pages/dashboard/over-due-tasks"));
const EmployeeTasksByStatus = loadable(() => import("pages/dashboard/employee-tasks-by-status"));
const RecurringProfilesTasks = loadable(() => import("pages/dashboard/recurringProfileTasks"));
const AllStatusTasks = loadable(() => import("pages/dashboard/AllStatusTasks"));
const TodayAttendanceFullView = loadable(() => import("views/dashboard/OrgDashboard/todayAttendance"));
const AnalyticsView = loadable(() => import("views/dashboard/OrgDashboard/loghour-analytics/service-analytics-view"));

//ROLES AND PERMISSIONS
const Roles = loadable(() => {
  return import("pages/settings/manage-users/roles-permissions");
});
const EditPermissions = loadable(() => {
  return import("pages/settings/manage-users/roles-permissions/edit-permissions");
});

// STORAGE MANAGEMENT
const StorageManagement = loadable(() => {
  return import("pages/settings/storage-management");
});
const OnedriveAuth = loadable(() => {
  return import("pages/onedrive-auth");
});

const OnedriveConnection = loadable(() => import("views/signup/OneDrive"));
const GoogledriveConnection = loadable(() => import("views/signup/GoogleDrive"));
const BharathCloudConnection = loadable(() => import("views/signup/BharthCloud"));

const OnedriveAuthSignup = loadable(() => {
  return import("pages/Onedrive");
});
const GoogledriveAuthSignup = loadable(() => import("pages/Googledrive"));

const GoogledriveAuth = loadable(() => {
  return import("pages/googledrive-auth");
});
const ZohoBooksAuth = loadable(() => import("pages/zoho-books-auth"));
const Storage = loadable(() => import("pages/storage"));
const MyStorage = loadable(() => import("views/storage/MyStorage"));
const AllClientsStorage = loadable(() => import("views/storage/AllClientsStorage"));
const CloudStorage = loadable(() => import("views/storage/Cloud"));
const GoogleDrive = loadable(() => import("views/storage/GoogleDrive"));
const OneDrive = loadable(() => import("views/storage/OneDrive"));
const BharathCloud = loadable(() => import("views/storage/BharathCloud"));

// FORMS
const Forms = loadable(() => import("pages/forms"));
const Esign = loadable(() => import("pages/forms/Esign"));
const FormTemplates = loadable(() => import("pages/forms/FormTemplates"));
const FormValidations = loadable(() => import("pages/forms/FormValidations"));
const FormBuilder = loadable(() => import("pages/forms/FormBuilder"));
const AccessForm = loadable(() => import("pages/forms/AccessForm"));

// IPRO
const ViewIproForm = loadable(() => import("pages/task-view/view-ipro"));
const ViewIproFormEntry = loadable(() => import("pages/task-view/view-ipro-entry"));
const IProAuditLog = loadable(() => import("pages/task-view/ipro-audit-log"));

// KYB DETAILS
const ViewKyb = loadable(() => import("pages/client-view/view-kyb"));

// SERVICES
const Services = loadable(() => import("pages/services"));
const AddService = loadable(() => import("pages/services/add-service"));
const ServiceView = loadable(() => import("pages/service-view"));
const ServiceOverView = loadable(() => import("pages/service-view/ServiceOverView"));
const ServiceInsights = loadable(() => import("pages/service-view/ServiceInsights"));
const ServiceDashboard = loadable(() => import("pages/service-view/Dashboard"));
const ComplianceTemplateView = loadable(() => import("views/services/Template/compliance-template-view"));

// REPORTS
const InvoiceReports = loadable(() => import("pages/reports/invoice-reports"));
const Reports = loadable(() => import("pages/reports"));
const LogHoursReport = loadable(() => import("pages/reports/log-hours-report"));
const EmployeeLogHoursReport = loadable(() => import("pages/reports/employee-log-hours-report"));
const EmployeeTimeSheetReport = loadable(() => import("pages/reports/EmployeeTimeSheetReport"));
const LogHourFeeReport = loadable(() => import("pages/reports/log-hours-fee"));
const ClientsReport = loadable(() => import("pages/reports/clients-report"));
const TasksReport = loadable(() => import("pages/reports/tasks-report"));
const MilestonesReport = loadable(() => import("pages/reports/milestones-report"));
const SubTaskReport = loadable(() => import("pages/reports/sub-task-report"));
const CommentsReport = loadable(() => import("pages/reports/comments-report"));
const OnHoldTaskReport = loadable(() => import("pages/reports/on-hold-task-report"))
const CustomReports = loadable(() => import("pages/reports/custom-reports"));
const TimesheetReports = loadable(() => import("pages/reports/timesheet-billable"));
const AttendanceReports = loadable(() => import("pages/reports/attendance"));
const DailyAttendanceReport = loadable(
  () => import("pages/reports/attendance-reports/daily-attendance-report")
);
const HalfDayReport = loadable(() => import("pages/reports/attendance-reports/half-day-report"));
const ShiftReport = loadable(() => import("pages/reports/attendance-reports/shift-report"));
const LeaveAbsenceReport = loadable(
  () => import("pages/reports/attendance-reports/leave-absence-report")
);
const OvertimeUndertimeReport = loadable(
  () => import("pages/reports/attendance-reports/overtime-undertime-report")
);
const LocationReport = loadable(() => import("pages/reports/attendance-reports/location-report"));
const MonthlySummaryReport = loadable(
  () => import("pages/reports/attendance-reports/monthly-summary-report")
);
const MonthlyTimesheetAttendanceReport = loadable(
  () => import("pages/reports/attendance-reports/monthly-timesheet-attendance-report")
);
const EfficiencyReports = loadable(() => import("pages/reports/efficiency"));
const PredefinedReports = loadable(() => import("pages/reports/predefined-reports"));
const StatusWiseTasks = loadable(() => import("pages/reports/status-wise-tasks"));
const ServiceCategoryStatusWiseTasks = loadable(
  () => import("pages/reports/service-category-status-wise-tasks")
);
const ServiceandSubCategoryWiseTasks = loadable(
  () => import("pages/reports/service-subcategory-wise-tasks")
);
const UserBasedMasterReport = loadable(() => import("pages/reports/user-based-master-report"));
const OverDueTasksReport = loadable(() => import("pages/reports/over-due-tasks-report"));
const DetailedOverDueTasksReport = loadable(
  () => import("pages/reports/detailed-over-due-tasks-report")
);
const DetailedOverDueCompletedTasksReport = loadable(
  () => import("pages/reports/detailed-over-due-completed-tasks")
);
const EfficiencyReport = loadable(() => import("pages/reports/efficiency-report"));
const HighestNoOfTaskCompletion = loadable(
  () => import("pages/reports/highest-task-completion-reports")
);
// Invoice REPORTS
const TasksCompletedToBilledTasksReport = loadable(
  () => import("pages/reports/invoice/TasksCompletedToBilledTasksReport")
);
const TasksCompletedToUnBilledTasksReport = loadable(
  () => import("pages/reports/invoice/TasksCompletedToUnBilledTasksReport")
);
const ClientWiseTasksCompletedToBilledReport = loadable(
  () => import("pages/reports/invoice/ClientWiseTasksCompletedToBilledReport")
);
const ClientWiseTasksCompletedToUnBilledReport = loadable(
  () => import("pages/reports/invoice/ClientWiseTasksCompletedToUnBilledReport")
);
const InvoiceOverDueReport = loadable(() => import("pages/reports/invoice/InvoiceOverDueReport"));
const BalanceDueForInvoicesRaisedReport = loadable(
  () => import("pages/reports/invoice/BalanceDueForInvoicesRaisedReport")
);
const ReceiptManagementReport = loadable(
  () => import("pages/reports/invoice/ReceiptManagementReport")
);

const InvoiceAgingReport = loadable(() => import("pages/reports/invoice/TaskInvoiceDetailsReport"));


const ProfomaInvoiceReport = loadable(() => import("pages/reports/invoice/ProfomaInvoiceReport"));

//BRODCAST
const Communication = loadable(() => import("pages/communication"));
const TeamDiscussion = loadable(() => import("pages/communication/team-discussion"));
const UserGroups = loadable(() => import("pages/communication/userTeams"));
const ClientGroups = loadable(() => import("pages/communication/clientGroups"));
const EmailPreview = loadable(
  () => import("pages/communication/templates/email/email-template-preview")
);
const ClientGroupView = loadable(
  () => import("pages/communication/clientGroups/client-group-view")
);
const ClientGroupTeamView = loadable(
  () => import("pages/communication/clientGroups/client-group-teamView")
);
const EmailTemplates = loadable(() => import("pages/communication/templates/email"));
const EmailTemplatesView = loadable(
  () => import("pages/communication/templates/email/add-email-template")
);
const EmailTemplatesEdit = loadable(
  () => import("pages/communication/templates/email/add-email-template")
);
const BroadcastMessage = loadable(() => import("pages/communication/broadcast/broadcast-message"));
const PosterConfiguration = loadable(
  () => import("pages/communication/templates/posterConfiguration")
);

const SendNotificationNotify = loadable(() => import("views/sendReminders/notificationNotify"));

const PosterSelect = loadable(() => import("pages/communication/templates/poster"));
const PosterDownloadPage = loadable(
  () => import("pages/communication/templates/poster/poster_download")
);

const PushNotifications = loadable(
  () => import("pages/communication/templates/push-notifications")
);

const ApprovalProcess = loadable(() => import("pages/settings/approval-process"));
const ApprovalProcedue = loadable(
  () => import("pages/settings/approval-process/approval-procedure")
);
const ApprovalProcedueView = loadable(
  () => import("pages/settings/approval-process/approval-procedure-view")
);
//vider connect

const Contacts = loadable(
  () => import("views/vider-connect/contacts")
);
const ViderConnectProfile = loadable(
  () => import("views/vider-connect/viderConnectProfile")
);
const Chats = loadable(
  () => import("views/vider-connect/chat-window")
);
//Automation income tax
const UnifiedCompliance = loadable(() => import("pages/atom-pro/UnifiedCompliance"));
const AtomPro = loadable(() => import("pages/atom-pro"));
const GstPro = loadable(() => import("pages/atom-pro/Gst"));
const McaPro = loadable(() => import("pages/atom-pro/Mca"));
const GStProDashboard = loadable(() => import("pages/atom-pro/Gst/dashboard"));
const Websites = loadable(() => import("pages/atom-pro/website"));
const IncomeTaxDashboard = loadable(() => import("pages/atom-pro/income-tax-dashboard"));
const OutstandingDemand = loadable(() => import("pages/atom-pro/outstanding-demand"));
const ClientsIncomeTax = loadable(() => import("pages/atom-pro/clients"));
const FyaNotice = loadable(() => import("views/atom-pro/eProceedingNotice/fyaNotice"));
const EproceedingNotice = loadable(
  () => import("views/atom-pro/eProceedingNotice/eproceedingNotice")
);
const Invalidate = loadable(() => import("views/atom-pro/invalidate"));
const AtomProCalendar = loadable(() => import("views/atom-pro/Dashboard/Calendar"));
const IncomeTaxLimitPage = loadable(() => import("views/atom-pro/Access/IncomeTaxLimit"));
const ClientChallan = loadable(() => import("views/atom-pro/clientChallan"));
const IncomeTaxChallans = loadable(() => import("pages/atom-pro/income-tax-challans"));
const EChallanFullView = loadable(() => import("views/atom-pro/eChallanFullView"));
const IncomeTaxMycas = loadable(() => import("pages/atom-pro/income-tax-mycas"));
const ClientMycas = loadable(() => import("views/atom-pro/clientMycas"));
const GstInvalidate = loadable(() => import("views/atom-pro/Gstr/invalidate"));

//BULK EDIT MODULE
const BulkEdit = loadable(() => import("pages/settings/bulk-activity"));
const TaskBulkEdit = loadable(() => import("pages/settings/bulk-activity/task-bulk-edit"));

//Wallets
// const WalletInfo = loadable(() => {
//   return import("layout/walletlayout")
// })

//Mails
const Mails = loadable(() => import("pages/mails"));
const Inbox = loadable(() => import("pages/mails/Inbox"));
const Sentbox = loadable(() => import("pages/mails/Sent"));
const MailFullView = loadable(() => import("pages/mails/GmailFullView"));
const ComposeMail = loadable(() => import("pages/mails/ComposeMail"));

//Approvals

const Approvals = loadable(() => import("pages/settings/approvals"));
const Attendance = loadable(() => import("pages/settings/approvals/attendence"));
const ApprovalPreferences = loadable(
  () => import("pages/settings/preferences/ApprovalPreferences")
);
//ATOM PRO GSTAT
const GstatPro = loadable(() => import("pages/atom-pro/Gstat"));
const GstatCalendar = loadable(() => import("pages/atom-pro/Gstat/Calendar"));
const GstatDashboard = loadable(() => import("pages/atom-pro/Gstat/dashboard"));
const GstatClients = loadable(() => import("pages/atom-pro/Gstat/clients"));
const GstatEfiledCases = loadable(() => import("pages/atom-pro/Gstat/efiled-cases"));
const GstatPayments = loadable(() => import("pages/atom-pro/Gstat/payments"));
const GstatReports = loadable(() => import("pages/atom-pro/Gstat/reports"));
const GstatNewUpdates = loadable(() => import("pages/atom-pro/Gstat/new-updates"));
const GstatUpdatesFullView = loadable(() => import("views/atom-pro/Gstat/updatesFullView"));
const GstatPreviousListings = loadable(() => import("pages/atom-pro/Gstat/previous-listings"));
const GstatSmsEmailList = loadable(() => import("pages/atom-pro/Gstat/sms-email-list"));
const GstatTransactionHistory = loadable(() => import("pages/atom-pro/Gstat/transaction-history"));
const GstatInvalidate = loadable(() => import("views/atom-pro/Gstat/invalidate"));
const GstatEfiledCaseFullView = loadable(() => import("views/atom-pro/Gstat/efiledCaseFullView"));
const GstatClientView = loadable(() => import("views/atom-pro/Gstat/client/gstatView"));
const GstatOverview = loadable(() => import("views/atom-pro/Gstat/client/overview"));
const GstatClientEfiledCases = loadable(
  () => import("views/atom-pro/Gstat/client/clientEfiledCases")
);
const GstatClientPayments = loadable(() => import("views/atom-pro/Gstat/client/clientPayments"));
const GstatClientTransactionHistory = loadable(
  () => import("views/atom-pro/Gstat/client/clientTransactionHistory")
);
const GstatClientActivityLog = loadable(
  () => import("views/atom-pro/Gstat/client/clientActivityLog")
);
const GstatClientSyncStatus = loadable(
  () => import("views/atom-pro/Gstat/client/clientSyncStatus")
);
//ATOM PRO TAN
const Tan = loadable(() => import("pages/atom-pro/Tan"));
const TanDashboard = loadable(() => import("pages/atom-pro/Tan/dashboard"));
const TanClients = loadable(() => import("pages/atom-pro/Tan/clients"));
const TanClientFullView = loadable(
  () => import("views/atom-pro/Tan/clientInsideView/clientFullView")
);
const TanClientIncomeTaxView = loadable(
  () => import("views/atom-pro/Tan/clientInsideView/ClientIncomeTaxView")
);
const TanClientChallan = loadable(() => import("views/atom-pro/Tan/clientView/clientChallan"));
const TanEChallanFullView = loadable(
  () => import("views/atom-pro/Tan/clientInsideView/eChallanFullView")
);
const TanFormFullView = loadable(() => import("views/atom-pro/Tan/clientInsideView/formFullView"));
const TanClientForm = loadable(() => import("views/atom-pro/Tan/clientView/clientForm"));
const TanIncomeTaxChallans = loadable(() => import("pages/atom-pro/Tan/income-tax-challans"));
const TanIncomeTaxForms = loadable(() => import("pages/atom-pro/Tan/income-tax-forms"));
const TanClientIncomeTaxActivityLog = loadable(
  () => import("views/atom-pro/Tan/clientInsideView/clientActivityLog")
);
const TanIncomeTaxReports = loadable(() => import("pages/atom-pro/Tan/reports"));
const TanClientAutoStatus = loadable(
  () => import("views/atom-pro/Tan/clientInsideView/clientAutoStatus")
);
const TanIncomeTaxMycas = loadable(() => import("pages/atom-pro//Tan/income-tax-mycas"));
const TanClientMycas = loadable(() => import("views/atom-pro/Tan/clientView/clientMycas"));
const TanNewUpdates = loadable(() => import("pages/atom-pro/Tan/new-updates"));
const TanUpdatesFullVIew = loadable(() => import("views/atom-pro/Tan/NewUpdates/ItemFullView"));
const DeletedIncomeTaxTanClients = loadable(() => import("pages/settings/deleted-incometaxtan"));
const TanTraceInvalidate = loadable(() => import("views/atom-pro/Tan/invalidate"));
const TanTdsFormAnalytics = loadable(() => import("views/atom-pro/Tan/tdsFormAnalytics"));
const TraceCommunication = loadable(() => import("pages/atom-pro/Tan/trace-communication"));
const TanTraceCommunication = loadable(
  () => import("views/atom-pro/Tan/clientView/clientCommunication")
);

//Income Tax Temp Notices
const IncomeTaxTempNotices = loadable(() => import("pages/atom-pro/income-tax-temp-notices"));
const ClientTempNotice = loadable(() => import("views/atom-pro/clientTempNotice"));
const TempNoticesFilterPage = loadable(
  () => import("views/atom-pro/eProceedingNotice/tempNotices")
);

const TanExcelNotices = loadable(() => import("pages/atom-pro/Tan/tan-excel-notices"));
const TanClientTempNotice = loadable(
  () => import("views/atom-pro/Tan/clientView/clientTempNotice")
);
const TempTanNoticesFilterPage = loadable(() => import("pages/atom-pro/Tan/tempNotices"));
const AtomProTanCalendar = loadable(() => import("views/atom-pro/Tan/Dashboard/Calendar"));
const NotFiledReturnsAnalytics = loadable(
  () => import("views/atom-pro/Dashboard/notFiledReturnsAnalytics")
);

const GstDemands = loadable(() => import("pages/atom-pro/Gst/GstDemands"));
const ClientDemands = loadable(() => import("views/atom-pro/Gstr/modules/clientDemands"));

const GstLedgers = loadable(() => import("pages/atom-pro/Gst/GstLedgers"));
const ClientLedgers = loadable(() => import("views/atom-pro/Gstr/modules/clientLedgers"));
const TanIncomeTaxDemands = loadable(() => import("pages/atom-pro/Tan/income-tax-demands"));
const TraceDemandFullView = loadable(() => import("views/atom-pro/Tan/clientInsideView/demandFullView"));
const TraceClientDemand = loadable(() => import("views/atom-pro/Tan/clientView/clientDemand"));
const IproFullView = loadable(() => import("views/dashboard/OrgDashboard/iProFullview"));
const ComplianceECampaign = loadable(() => import("pages/atom-pro/Compliance/compliance-e-campaign"));
const ClientECampaign = loadable(() => import('views/atom-pro/Compliance/ClientECampaign'));
const IncomeTaxDscRegister = loadable(() => import("pages/atom-pro/income-tax-dsc-registers"));
const ClientRequests = loadable(() => import('pages/client-view/client-requests'));
const RequestTasks = loadable(() => import("views/client-view/client-requests/tasks"));
const RequestDocuments = loadable(() => import("views/client-view/client-requests/documents"));
const RequestEvents = loadable(() => import("views/client-view/client-requests/events"));
const ClientFormMyCas = loadable(() => import("views/atom-pro/clientFormMyCas"));
const IncomeTaxFormMyca = loadable(() => import("pages/atom-pro/income-tax-forms-myca"));
const RedVouch = loadable(() => import("pages/red-vouch"));
const TanIncomeTaxFormMyca = loadable(() => import("pages/atom-pro/Tan/income-tax-forms-myca"));
const TanClientFormMyCas = loadable(
  () => import("views/atom-pro/Tan/clientView/clientFormMyCas")
);
const GstrPanGroupView = loadable(
  () => import("views/atom-pro/Gstr/gstr-client/panGroupView")
);
const Trademark = loadable(() => import("../pages/atom-pro/trademark"));

function RoutesContainer() {

  return (
    // <Router>
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="dashboard" />} />
        <Route path="attachment-ai" element={<AttachmentAI />} />
        {/* <Route path="vider-connect" element={<ViderConnect/>} /> */}
        <Route path="vider-connect" element={
          <PageWithPermission name={Permissions.MANAGE_VIDER_CONNECT}>
            <ViderConnect />
          </PageWithPermission>
        }>
          {/* <Route index element={<Navigate to="chats" replace />} /> */}

          <Route path="chats" element={<Chats />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="profile" element={<ViderConnectProfile />} />
          {/* <Route path="messages" element={<Messages />} /> */}
        </Route>

        <Route path="dashboard">
          <Route index element={<Dashboard />} />
          <Route path="ipro-fullview" element={<IproFullView />} />
          <Route path="task-status-by-client-navigate" element={<TaskStatusByClientNavigate />} />
          <Route path="today-attendance" element={<TodayAttendanceFullView />} />
          <Route path="tasks-by-service" element={<TasksByService />} />
          <Route path="client-by-category" element={<ClientByCategory />} />
          <Route path="client-categories" element={<ClientCategory />} />
          <Route path="service-categories" element={<ServiceCategory />} />
          <Route path="employee-time-sheet" element={<TimesheetFiledVsNotFiledFullView />} />
          <Route path="over-due-tasks" element={<OverDueTasks />} />
          <Route path="RecurringProfilesTasks" element={<RecurringProfilesTasks />} />
          <Route path="allTasks" element={<AllStatusTasks />} />
          <Route path="employee-tasks-by-status" element={<EmployeeTasksByStatus />} />
          <Route path="service-task-analytics" element={<AnalyticsView />} />
        </Route>

        <Route path="red-vouch" element={<RedVouch />} />

        <Route path="ondemand">
          <Route index element={<Ondemand />} />
        </Route>

        {/* <Route
            path="categories"
            element={
              <PageWithPermission name={Permissions.VIEW_CATEGORIES}>
                <Categories />
              </PageWithPermission>
            }
          /> */}

        <Route path="calendar" element={<Calendar />} />
        <Route path="create-task">
          <Route index element={<CreateTask />} />
        </Route>
        <Route path="planner">
          <Route index element={<Planner />} />
        </Route>
        {/* <PageWithPermission name={Permissions.VIEW_REPORTS}>
              <GstrClients />
              </PageWithPermission> */}

        {/* automation  part*/}
        <Route path="atom-pro">
          <Route
            index
            element={
              <PageWithPermission name={Permissions.VIEW_ATOM_PRO}>
                <Websites />
              </PageWithPermission>
            }
          />
          <Route
            path="income-tax"
            element={
              <PageWithPermission name={Permissions.VIEW_INCOME_TAX}>
                <AtomPro />
              </PageWithPermission>
            }
          >
            <Route index element={<IncomeTaxDashboard />} />
            <Route path="demands" element={<OutstandingDemand />} />
            {/* <Route path="clients" element={<ClientsIncomeTax />} /> */}
            <Route path="returns" element={<IncomeTaxReturns />} />
            <Route path="dashboard" element={<IncomeTaxDashboard />} />
            <Route path="clients" element={<ClientsIncomeTax />} />
            <Route path="calendar" element={<AtomProCalendar />} />
            <Route path="return/:id" element={<ReturnFullView />} />
            <Route path="demand/:id" element={<OutstandingDemandView />} />
            <Route path="proceeding-action/:id" element={<EproceedingView />} />
            <Route path="proceeding-information/:id" element={<EproceedingFyiView />} />
            <Route path="proceeding-action/notice-fya/:itemId" element={<FYANoticeView />} />
            <Route path="proceeding-information/notice-fyi/:itemId" element={<FYINoticeView />} />
            <Route path="forms" element={<IncomeTaxFormMyca />} />
            <Route path="my-cas" element={<IncomeTaxMycas />} />
            <Route path="challans" element={<IncomeTaxChallans />} />
            <Route path="proceedings" element={<IncomeTaxEProceedings />} />
            <Route path="temp-notices" element={<IncomeTaxTempNotices />} />
            <Route path="compliance" element={<ComplianceECampaign />} />
            <Route path="order" element={<IncomeTaxOrder />} />
            <Route path="forms/:id" element={<FormFullView />} />
            <Route path="e-challan/:id" element={<EChallanFullView />} />
            <Route path="client/:id" element={<ClientFullView />} />
            <Route path="reports" element={<IncomeTaxReports />} />
            <Route path="new-updates" element={<NewUpdates />} />
            <Route path="new-updates/:id" element={<UpdatesFullVIew />} />
            <Route path="fya-notice" element={<FyaNotice />} />
            <Route path="eproceeding-notice" element={<EproceedingNotice />} />
            <Route path="temp-notice" element={<TempNoticesFilterPage />} />
            <Route path="invalidate" element={<Invalidate />} />
            <Route path="return-filings" element={<NotFiledReturnsAnalytics />} />
            <Route path="registers-dsc" element={<IncomeTaxDsc />} />
            <Route path="bank-acc-details" element={<IncomeTaxBankAccDeatils />} />
            <Route path="incometax/:incometaxid" element={<ClientIncomeTaxView />}>
              <Route index element={<ClientFullView />} />
              <Route path="form" element={<ClientFormMyCas />} />
              <Route path="demand" element={<ClientDemand />} />
              <Route path="proceeding" element={<ClientProceeding />} />
              <Route path="temp-notice" element={<ClientTempNotice />} />
              <Route path="form/:id" element={<FormFullView />} />
              <Route path="my-cas" element={<ClientMycas />} />
              <Route path="e-challan/:id" element={<EChallanFullView />} />
              <Route path="challan" element={<ClientChallan />} />
              <Route path="return" element={<ClientIncometaxReturns />} />
              <Route path="return/:id" element={<ReturnFullView />} />
              <Route path="demand" element={<OutstandingDemand />} />
              <Route path="eCampaign" element={<ClientECampaign />} />
              {/* <Route path="activity" element={<ClientIncomeTaxActivityLog />} /> */}
              <Route path="activity" element={<ClientIncomeTaxActivity />} />
              <Route path="activity/:tab" element={<ClientIncomeTaxActivity />} />
              {/* <Route path="client-status" element={<ClientAutoStatus />} /> */}
              {/* <Route path="proceeding" element={<IncomeTaxEProceedings />} /> */}
            </Route>
          </Route>

          <Route
            path="gst"
            element={
              <PageWithPermission name={Permissions.VIEW_GSTR}>
                <GstPro />
              </PageWithPermission>
            }
          >
            <Route path="dashboard" element={<GstrDashboard />} />
            <Route path="regular" element={<GstRegular />} />
            <Route path="collector" element={<GstCollector />} />
            <Route path="deductor" element={<GstDeductor />} />
            <Route path="distributor" element={<GstDistributor />} />
            <Route path="clients" element={<GstrClients />} />
            <Route path="pan-group/:pan" element={<GstrPanGroupView />} />
            <Route path="add-notice-orders" element={<AdditionalOrdersAndNotices />} />
            <Route path="download-reports" element={<GstReports />} />
            <Route path="return-reports" element={<GstReturnReports />} />
            <Route path="notice-orders" element={<NoticesAndOrders />} />
            <Route path="demands" element={<GstDemands />} />
            <Route path="ledgers" element={<GstLedgers />} />
            <Route path="reports" element={<GstrReports />} />
            <Route path="add-notice-order/:id" element={<AdditionalRecordsView />} />
            <Route path="notice-order/:id" element={<NoticeAndOrderView />} />
            <Route path="calendar" element={<GstrCalendar />} />
            <Route path="new-updates" element={<NewGstrUpdates />} />
            <Route path="new-updates/:id" element={<UpdatesGstrFullView />} />
            <Route path="invalidate" element={<GstInvalidate />} />
            <Route path="gstr/:gstrid" element={<GstrView />}>
              <Route index element={<GstrProfile />} />
              <Route path="compliance" element={<GstrCompliance />} />
              <Route path="additional-notice" element={<AdditionalNotice />} />
              <Route path="notice-orders" element={<NoticeAndOrders />} />
              <Route path="demand" element={<ClientDemands />} />
              <Route path="ledger" element={<ClientLedgers />} />
              <Route path="notice-orders/:id" element={<NoticeAndOrderFullView />} />
              <Route path="additional-notice/:id" element={<AdditonalNoticeFullView />} />
              <Route path="download-reports" element={<GstReportsFullView />} />
              <Route path="activity-log" element={<ClientGstrActivity />} />
              <Route path="sync-status" element={<ClientSyncStatus />} />
            </Route>
          </Route>
          <Route
            path="gstat"
            element={
              <PageWithPermission name={Permissions.VIEW_GSTR}>
                <GstatPro />
              </PageWithPermission>
            }
          >
            <Route index element={<GstatDashboard />} />
            <Route path="dashboard" element={<GstatDashboard />} />
            <Route path="clients" element={<GstatClients />} />
            <Route path="calendar" element={<GstatCalendar />} />
            <Route path="efiled-cases" element={<GstatEfiledCases />} />
            <Route path="efiled-case/:caseId" element={<GstatEfiledCaseFullView />} />
            <Route path="payments" element={<GstatPayments />} />
            <Route path="previous-listings" element={<GstatPreviousListings />} />
            <Route path="sms-email-list" element={<GstatSmsEmailList />} />
            <Route path="transaction-history" element={<GstatTransactionHistory />} />
            <Route path="reports" element={<GstatReports />} />
            <Route path="new-updates" element={<GstatNewUpdates />} />
            <Route path="new-updates/:id" element={<GstatUpdatesFullView />} />
            <Route path="invalidate" element={<GstatInvalidate />} />
            <Route path="client/:gstatid" element={<GstatClientView />}>
              <Route index element={<GstatOverview />} />
              <Route path="efiled-cases" element={<GstatClientEfiledCases />} />
              <Route path="efiled-cases/:caseId" element={<GstatEfiledCaseFullView />} />
              <Route path="payments" element={<GstatClientPayments />} />
              <Route path="transaction-history" element={<GstatClientTransactionHistory />} />
              <Route path="activity-log" element={<GstatClientActivityLog />} />
              <Route path="sync-status" element={<GstatClientSyncStatus />} />
            </Route>
          </Route>
          <Route path="incomeTaxLimit" element={<IncomeTaxLimitPage />} />
          <Route path="income-tax-tan" element={<Tan />}>
            <Route path="dashboard" element={<TanDashboard />} />
            <Route path="clients" element={<TanClients />} />
            <Route path="calendar" element={<AtomProTanCalendar />} />
            <Route path="e-challans" element={<TanIncomeTaxChallans />} />
            <Route path="e-challan/:id" element={<TanEChallanFullView />} />
            <Route path="forms" element={<TanIncomeTaxFormMyca />} />
            <Route path="proceedings-excel" element={<TanExcelNotices />} />
            <Route path="traces-communication" element={<TraceCommunication />} />
            <Route path="demand" element={<TanIncomeTaxDemands />} />
            <Route path="form/:id" element={<TanFormFullView />} />
            <Route path="demand/:id" element={<TraceDemandFullView />} />
            <Route path="my-cas" element={<TanIncomeTaxMycas />} />
            <Route path="reports" element={<TanIncomeTaxReports />} />
            <Route path="new-updates" element={<TanNewUpdates />} />
            <Route path="new-updates/:id" element={<TanUpdatesFullVIew />} />
            <Route path="invalidate" element={<TanTraceInvalidate />} />
            <Route path="tds-forms" element={<TanTdsFormAnalytics />} />
            <Route path="e-proceeding-excel" element={<TempTanNoticesFilterPage />} />
            <Route path="incometax/:incometaxid" element={<TanClientIncomeTaxView />}>
              <Route index element={<TanClientFullView />} />
              <Route path="challan" element={<TanClientChallan />} />
              <Route path="e-challan/:id" element={<TanEChallanFullView />} />
              <Route path="form" element={<TanClientFormMyCas />} />
              <Route path="proceedings-excel" element={<TanClientTempNotice />} />
              <Route path="traces-communication" element={<TanTraceCommunication />} />
              <Route path="demand" element={<TraceClientDemand />} />
              <Route path="form/:id" element={<TanFormFullView />} />
              <Route path="demand/:id" element={<TraceDemandFullView />} />
              <Route path="my-cas" element={<TanClientMycas />} />
              <Route path="activity" element={<TanClientIncomeTaxActivityLog />} />
              <Route path="client-status" element={<TanClientAutoStatus />} />
            </Route>
          </Route>

          <Route
            path="mca"
            element={
              <PageWithPermission name={Permissions.VIEW_GSTR}>
                <McaPro />
              </PageWithPermission>
            }
          >
            <Route path="dashboard" element={<McaDashboard />} />
            <Route path="services" element={<McaServices />} />
            <Route path="clients" element={<McaClients />} />
            <Route path="services/master-data" element={<McaMasterData />} />
            <Route path="services/filling-status" element={<McaFillingStatus />} />
            <Route path="services/check-company-llp-details" element={<McaCompanyDetails />} />
            <Route path="late-fee-calculator" element={<McaLateFeeCalculator />} />
          </Route>
        <Route path="unified-compliance" element={<UnifiedCompliance />} />
        <Route path="knowledge-base" element={<KnowledgeBase />} />
        <Route path="trademark" element={<Trademark />}/>
        </Route>

        <Route path="orgChart" element={<OrgChart />} />

        <Route path="attendance" element={<Attendance />} />
        <Route path="clients/" element={<Billingclientoverview />} />
        <Route path="clients-group/" element={<Billingclientoverview />} />
        <Route path="clients-group/:clientGroupId" element={<Billingclientview />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="credit-note" element={<CreditNotes />} />
        <Route path="receipts" element={<Receipts />} />
        <Route path="expenditure" element={<Expenditure />} />
        <Route path="gst" element={<Gst />} />
        <Route path="tds" element={<Tds />} />
        <Route path="proforma" element={<Proforma />} />
        <Route path="clients" element={<BillingClients />} />
        {/* </Route> */}

        <Route path="mails" element={<Mails />}>
          {/* <Route index element={<Mails />} /> */}
          <Route path="inbox" element={<Inbox />} />
          <Route path="sent" element={<Sentbox />} />
          <Route path=":gmailId" element={<MailFullView />} />
          <Route path="compose" element={<ComposeMail />} />
        </Route>

        <Route
          path="reports"
          element={
            <Reports />
          }
        >
          {/* <Route
              index
              element={
                <PageWithPermission name={Permissions.VIEW_REPORTS}>
                  <Reports />
                </PageWithPermission>
              }
            /> */}
          <Route index element={<PredefinedReports />} />
          <Route path="status-wise-tasks" element={<StatusWiseTasks />} />
          <Route
            path="service-category-status-wise-tasks"
            element={<ServiceCategoryStatusWiseTasks />}
          />
          <Route
            path="service-subcategory-wise-tasks"
            element={<ServiceandSubCategoryWiseTasks />}
          />
          <Route path="user-based-master-report" element={<UserBasedMasterReport />} />
          <Route path="milestones-report" element={<MilestonesReport />} />
          <Route path="over-due-tasks-report" element={<OverDueTasksReport />} />
          <Route path="detailed-over-due-tasks-report" element={<DetailedOverDueTasksReport />} />
          <Route
            path="detailed-over-due-completed-tasks"
            element={<DetailedOverDueCompletedTasksReport />}
          />
          <Route path="efficiency-report" element={<EfficiencyReport />} />
          <Route path="highest-task-completion-reports" element={<HighestNoOfTaskCompletion />} />
          <Route
            path="TasksCompletedToBilledTasksReport"
            element={<TasksCompletedToBilledTasksReport />}
          />
          <Route
            path="TasksCompletedToUnBilledTasksReport"
            element={<TasksCompletedToUnBilledTasksReport />}
          />
          <Route
            path="ClientWiseTasksCompletedToBilledReport"
            element={<ClientWiseTasksCompletedToBilledReport />}
          />
          <Route
            path="ClientWiseTasksCompletedToUnBilledReport"
            element={<ClientWiseTasksCompletedToUnBilledReport />}
          />
          <Route path="InvoiceOverDueReport" element={<InvoiceOverDueReport />} />
          <Route
            path="BalanceDueForInvoicesRaisedReport"
            element={<BalanceDueForInvoicesRaisedReport />}
          />
          <Route path="ReceiptManagementReport" element={<ReceiptManagementReport />} />
          <Route path="TaskInvoiceDetailsReport" element={<InvoiceAgingReport />} />
          <Route path="ProfomaInvoiceReport" element={<ProfomaInvoiceReport />} />
          <Route path="invoice-reports" element={<InvoiceReports />} />
          <Route path="custom-reports" element={<CustomReports />} />
          <Route path="timesheet" element={<TimesheetReports />} />
          <Route path="attendance" element={<AttendanceReports />} />
          <Route
            path="attendance/daily-attendance-report"
            element={<DailyAttendanceReport />}
          />
          <Route path="attendance/half-day-report" element={<HalfDayReport />} />
          <Route path="attendance/shift-report" element={<ShiftReport />} />
          <Route path="attendance/leave-absence-report" element={<LeaveAbsenceReport />} />
          <Route
            path="attendance/overtime-undertime-report"
            element={<OvertimeUndertimeReport />}
          />
          <Route path="attendance/location-report" element={<LocationReport />} />
          <Route path="attendance/monthly-summary-report" element={<MonthlySummaryReport />} />
          <Route
            path="attendance/monthly-timesheet-attendance-report"
            element={<MonthlyTimesheetAttendanceReport />}
          />
          <Route path="efficiency" element={<EfficiencyReports />} />
          <Route path="log-hours-report" element={<LogHoursReport />} />
          <Route path="on-hold-report" element={<OnHoldTaskReport />} />

          <Route path="log-hours-fee" element={<LogHourFeeReport />} />

          <Route path="employee-log-hours-report" element={<EmployeeLogHoursReport />} />
          <Route path="employee-attendance-report" element={<EmployeeAttendanceReport />} />
          <Route
            path="employee-attendance-and-timesheet-report"
            element={<EmployeeAttendanceandTimesheetReport />}
          />
          <Route path="clients-report" element={<ClientsReport />} />
          <Route path="tasks-report" element={<TasksReport />} />
          <Route path="sub-task-report" element={<SubTaskReport />} />
          <Route path="on-hold-task-report" element={<OnHoldTaskReport />} />
          <Route path="comments-report" element={<CommentsReport />} />

          <Route path="employee-TimeSheet-report" element={<EmployeeTimeSheetReport />} />
        </Route>
        <Route path="billing" element={<Billing />}>
          <Route path="clients/:clientId" element={<Billingclientview />} />
          <Route path="clients/" element={<Billingclientoverview />} />
          <Route path="clients-group/" element={<Billingclientoverview />} />
          <Route path="clients-group/:clientGroupId" element={<Billingclientview />} />
          <Route path="unbilled-tasks" element={<UnbilledTasks />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="receipts" element={<Receipts />} />
          <Route path="credit-note" element={<CreditNotes />} />
          <Route path="expenditure" element={<Expenditure />} />
          <Route path="gst" element={<Gst />} />
          <Route path="receivable" element={<GstReceivable />} />
          <Route path="tds" element={<Tds />} />
          <Route path="proforma" element={<Proforma />} />
          <Route path="clients" element={<BillingClients />} />
          <Route path="dashboard" element={
            <PageWithPermission name={Permissions.BILLING_DASHBOARD_VIEW}>
              <BillingDashboard />
            </PageWithPermission>
          } />
        </Route>
        <Route path="communication" element={<Communication />}>
          <Route path="user-teams" element={<UserGroups />} />
          <Route path="whatsapp-inbox" element={<Conversation />} />
          <Route path="whatsapp-create-templates" element={<WhatsAppTemplateCreator />} />
          <Route path="whatsapp-templates" element={<WhatsappTemplates />} />

          {/* <Route path="user-teams/:userGroupId" element={<UserView />} /> */}
          <Route path="team-discussion" element={<TeamDiscussion />} />
          <Route path="whatsapp-inbox" element={<Conversation />} />
          <Route path="whatsapp-create-templates" element={<WhatsAppTemplateCreator />} />
          <Route path="whatsapp-templates" element={<WhatsappTemplates />} />
          <Route
            path="client-groups"
            element={
              <PageWithPermission name={Permissions.BROADCAST_CLIENT_GROUP_VIEW}>
                <ClientGroups />
              </PageWithPermission>
            }
          />
          <Route path="client-groups/:id" element={<ClientGroupView />} />
          <Route path="client-groups/:userGroupId/:id" element={<ClientGroupTeamView />} />
          <Route
            path="email"
            element={
              <PageWithPermission name={Permissions.BROADCAST_EMAIL_TEMPLATES_VIEW}>
                <EmailTemplates />
              </PageWithPermission>
            }
          />
          <Route path="email/:emailTemplateView" element={<EmailTemplatesView />} />
          {/* <Route path="email-templates" element={<AllEmailTemplates />} /> */}
          <Route path="email/:emailTemplateView" element={<EmailTemplatesView />} />
          <Route
            path="broadcast-message"
            element={
              <PageWithPermission name={Permissions.BROADCAST_BROADCAST_MESSAGE_VIEW}>
                <BroadcastMessage />
              </PageWithPermission>
            }
          />
          <Route
            path="broadcast-message/:broadcastActivityId"
            element={<BroadcastMessageDetails />}
          />
          <Route path="posterConfiguration" element={<PosterConfiguration />} />
          <Route path="posterSelect" element={<PosterSelect />} />
          <Route path="posterSelect/poster_download" element={<PosterDownloadPage />} />

          <Route
            path="broadcast-message"
            element={
              <PageWithPermission name={Permissions.BROADCAST_BROADCAST_MESSAGE_VIEW}>
                <BroadcastMessage />
              </PageWithPermission>
            }
          />
          <Route
            path="broadcast-message/:broadcastActivityId"
            element={<BroadcastMessageDetails />}
          />

          <Route path="email/:emailTemplateId/EmailTemplatePreview" element={<EmailPreview />} />
          <Route
            path="email/:emailTemplateId/EmailTemplateEdit"
            element={<EmailTemplateEdit />}
          />

          <Route path="push-notifications" element={<PushNotifications />} />
          <Route path="communication/sendNotifications" element={<SendNotifications />} />
          <Route path="/communication/sendNotifications/notify" element={<NotificationNotify />} />
          <Route path="communication/remindersSent" element={<ReminderSent />} />

          <Route
            path="reminder-details/:reminderDetailsId"
            element={<ReminderDetails />}
          />

        </Route>
        <Route path="billing/invoices/add" element={<AddInvoice />} />
        <Route path="billing/credit-note/add" element={<AddCreditNote />} />
        <Route path="billing/receipts/add" element={<AddReceipt />} />
        <Route path="billing/proforma/add" element={<AddProforma />} />
        {/* <Route path="billing/invoices/:invoiceId/receipt" element={<AddInvoiceReceipt />} />  */}
        <Route path="billing/receipts/:receiptId/edit" element={<EditReceipt />} />
        <Route path="billing/invoices/:invoiceId/edit" element={<EditInvoice />} />
        <Route path="billing/credit-note/:creditNoteId/edit" element={<EditCreditNote />} />
        <Route path="billing/proforma/:proformaId/edit" element={<EditProforma />} />
        <Route path="/billing/proforma/:proformaId/convert" element={<ConvertInvoice />} />
        <Route path="storage" element={<Storage />}>

          <Route
            path="my-storage"
            element={
              <PageWithPermission name={Permissions.VIEW_STORAGE}>
                <MyStorage />
              </PageWithPermission>
            }
          />
          <Route
            path="cloud-storage"
            element={
              <PageWithPermission name={Permissions.VIEW_STORAGE}>
                <CloudStorage />
              </PageWithPermission>
            }
          >
            <Route path="google-drive" element={<GoogleDrive />} />
            <Route path="one-drive" element={<OneDrive />} />
            <Route path="bharath-cloud" element={<BharathCloud />} />
          </Route>
          <Route
            path="all-clients-storage"
            element={
              <PageWithPermission name={Permissions.VIEW_CLIENT_STORAGE}>
                <AllClientsStorage />
              </PageWithPermission>
            }
          />
        </Route>
        <Route path="forms" element={<Forms />}>
          <Route index element={<FormTemplates />} />
          <Route path="form-validations" element={<FormValidations />} />
        </Route>
        <Route path="task-board">
          <Route
            index
            element={
              <PageWithPermission
                name={[Permissions.VIEW_ALL_TASKS, Permissions.VIEW_ASSIGNED_TASKS]}
              >
                <TaskBoard />
              </PageWithPermission>
            }
          />
          <Route path="gstrTaskView" element={<GstrTaskView />} />
          <Route path="GstrTaskIndex" element={<GstrTaskIndex />} />
          <Route path="tasks-bulk-import" element={<TasksBulkImport />} />
          <Route
            path=":taskId"
            element={
              <PageWithPermission name={[Permissions.VIEW_ASSIGNED_TASKS]}>
                <TasksView />
              </PageWithPermission>
            }
          />
        </Route>

        <Route
          path="leads"
          element={
            <PageWithPermission name={Permissions.VIEW_LEADS}>
              <Leads />
            </PageWithPermission>
          }
        />
        <Route
          path="leads/:leadId"
          element={
            <PageWithPermission name={Permissions.VIEW_LEADS}>
              <LeadView />
            </PageWithPermission>
          }
        />
        <Route
          path="leads/:leadId/documents/new"
          element={
            <PageWithPermission name={Permissions.VIEW_LEADS}>
              {/* adding / editing a lead document needs Edit on leads */}
              <PageWithPermission name={Permissions.EDIT_LEADS}>
                <LeadDocumentEditor />
              </PageWithPermission>
            </PageWithPermission>
          }
        />
        <Route
          path="leads/:leadId/documents/:docId/edit"
          element={
            <PageWithPermission name={Permissions.VIEW_LEADS}>
              {/* adding / editing a lead document needs Edit on leads */}
              <PageWithPermission name={Permissions.EDIT_LEADS}>
                <LeadDocumentEditor />
              </PageWithPermission>
            </PageWithPermission>
          }
        />
        <Route
          path="leads/:leadId/documents/:docId/preview"
          element={
            <PageWithPermission name={Permissions.VIEW_LEADS}>
              <LeadDocumentPreview />
            </PageWithPermission>
          }
        />
        <Route
          path="leads/:leadId/documents/templates/:templateId/preview"
          element={
            <PageWithPermission name={Permissions.VIEW_LEADS}>
              {/* a template preview also needs View on Document Templates */}
              <PageWithPermission name={Permissions.VIEW_DOCUMENT_TEMPLATES}>
                <LeadDocumentPreview />
              </PageWithPermission>
            </PageWithPermission>
          }
        />
        <Route path="lead-document-templates">
          <Route
            index
            element={
              <PageWithPermission name={Permissions.VIEW_DOCUMENT_TEMPLATES}>
                <LeadDocumentTemplates />
              </PageWithPermission>
            }
          />
          <Route
            path="add"
            element={
              <PageWithPermission name={Permissions.CREATE_DOCUMENT_TEMPLATES}>
                <LeadDocumentTemplateEditor />
              </PageWithPermission>
            }
          />
          <Route
            path=":templateId/edit"
            element={
              <PageWithPermission name={Permissions.EDIT_DOCUMENT_TEMPLATES}>
                <LeadDocumentTemplateEditor />
              </PageWithPermission>
            }
          />
          <Route
            path=":templateId/preview"
            element={
              <PageWithPermission name={Permissions.VIEW_DOCUMENT_TEMPLATES}>
                <LeadDocumentTemplatePreview />
              </PageWithPermission>
            }
          />
        </Route>
        <Route path="services">
          <Route index element={<Services />} />
          {/* <Route path="add" element={<AddService />} /> */}
          <Route
            path="add"
            element={
              <PathWithPermission name={Permissions.CREATE_SERVICES} path={"/services/add"}>
                <AddService />
              </PathWithPermission>
            }
          />
          <Route path=":serviceId" element={<ServiceView />}>
            <Route path="overview" element={<ServiceOverView />} />
            <Route path="insights" element={<ServiceInsights />} />
            <Route
              path="dashboard"
              element={
                <PageWithPermission name={Permissions.VIEW_SERVICE_DASHBOARD}>
                  <PageWithPermission name={Permissions.VIEW_ALL_TASKS}>
                    <ServiceDashboard />
                  </PageWithPermission>
                </PageWithPermission>
              }
            />
          </Route>
          <Route path="template">
            <Route path=":templateId" element={<ComplianceTemplateView />} />
          </Route>
        </Route>

        <Route path="client-requests" element={<ClientRequests />}>
          <Route index element={
            <RequestTasks />
          } />
          <Route path="documents" element={
            <RequestDocuments />
          } />
          <Route path="events" element={<RequestEvents />} />
        </Route>
        <Route path="clients">
          <Route
            index
            element={
              <PageWithPermission name={Permissions.VIEW_CLIENTS}>
                <Clients />
              </PageWithPermission>
            }
          />
          <Route
            path="import-data"
            element={
              <ImportData />
            }
          />
          <Route path=":clientId" element={<ClientView />}>
            <Route
              path="kyb-info"
              element={
                <PageWithPermission name={Permissions.VIEW_EXPIRY_MANAGEMENT}>
                  <KybInfo />
                </PageWithPermission>
              }
            />
            <Route
              path="credentials"
              element={
                <PageWithPermission name={Permissions.VIEW_CLIENT_PASSWORDS}>
                  <Credentials />
                </PageWithPermission>
              }
            />
            <Route
              path="attachments"
              element={
                <PageWithPermission name={Permissions.VIEW_CLIENT_ATTACHMENTS}>
                  <Attachments />
                </PageWithPermission>
              }
            />
            <Route
              path="recurring-profile"
              element={
                <PageWithPermission name={Permissions.VIEW_CLIENT_RECURRING_PROFILE}>
                  <RecurringProfile />
                </PageWithPermission>
              }
            />
            <Route
              path="profile"
              element={
                <PageWithPermission name={Permissions.VIEW_CLIENT_PROFILE}>
                  <ProfileDetails />
                </PageWithPermission>
              }
            />
            <Route
              path="group-profile"
              element={
                <PageWithPermission name={Permissions.VIEW_CLIENT_GROUP_PROFILE}>
                  <GroupProfileDetails />
                </PageWithPermission>
              }
            />
            <Route path="compliance" element={<GstReturns />} />
            <Route path="archives" element={<Archives />} />
            <Route path="upcoming-tasks" element={<UpComingTasks />} />
            <Route path="client-tasks" element={<Tasks />} />
            <Route path="roles-permissions" element={<ViewProfile />} />
            <Route path="client-activitylog" element={<ClientActivityLog />} />
            {/* <Route path="client-quantum-documents" element={<ClientQuantumDocuments />} /> */}
            <Route path="client-quantum-documents" element={<ClientQuantumDocumets />} />

            <Route path="dsc-register">
              <Route
                index
                element={
                  <PageWithPermission name={Permissions.VIEW_DSC_REGISTER}>
                    <ClientDscRegister />
                  </PageWithPermission>
                }
              />
              <Route
                path=":dscId"
                element={
                  <PageWithPermission name={Permissions.VIEW_DSC_REGISTER}>
                    <ClientDscRegisterView />
                  </PageWithPermission>
                }
              />
            </Route>
          </Route>
        </Route>
        <Route path="clients-group">
          <Route
            index
            element={
              <PageWithPermission name={Permissions.VIEW_CLIENT_GROUPS}>
                <ClientsGroup />
              </PageWithPermission>
            }
          />
          <Route path=":clientId" element={<ClientView />}>
            <Route
              path="kyb-info"
              element={
                <PageWithPermission name={Permissions.VIEW_EXPIRY_MANAGEMENT}>
                  <KybInfo />
                </PageWithPermission>
              }
            />
            <Route
              path="credentials"
              element={
                <PageWithPermission name={Permissions.VIEW_CLIENT_GROUP_PASSWORDS}>
                  <Credentials />
                </PageWithPermission>
              }
            />
            <Route
              path="attachments"
              element={
                <PageWithPermission name={Permissions.VIEW_CLIENT_GROUP_ATTACHMENTS}>
                  <Attachments />
                </PageWithPermission>
              }
            />
            <Route
              path="recurring-profile"
              element={
                <PageWithPermission name={Permissions.VIEW_CLIENT_GROUP_RECURRING_PROFILE}>
                  <RecurringProfile />
                </PageWithPermission>
              }
            />
            <Route
              path="profile"
              element={
                <PageWithPermission name={Permissions.VIEW_CLIENT_PROFILE}>
                  <ProfileDetails />
                </PageWithPermission>
              }
            />
            <Route
              path="group-profile"
              element={
                <PageWithPermission name={Permissions.VIEW_CLIENT_GROUP_PROFILE}>
                  <GroupProfileDetails />
                </PageWithPermission>
              }
            />
            <Route path="compliance" element={<GstReturns />} />
            <Route path="archives" element={<Archives />} />
            <Route path="upcoming-tasks" element={<UpComingTasks />} />
            <Route path="client-tasks" element={<Tasks />} />
            {/* <Route path="roles-permissions" element={<ViewProfile />} /> */}
            <Route path="client-activitylog" element={<ClientActivityLog />} />
            {/* <Route path="client-quantum-documents" element={<ClientQuantumDocuments />} /> */}
            <Route path="client-quantum-documents" element={<ClientQuantumDocumets />} />

            <Route path="dsc-register">
              <Route
                index
                element={
                  <PageWithPermission name={Permissions.VIEW_DSC_REGISTER}>
                    <ClientDscRegister />
                  </PageWithPermission>
                }
              />
              <Route
                path=":dscId"
                element={
                  <PageWithPermission name={Permissions.VIEW_DSC_REGISTER}>
                    <ClientDscRegisterView />
                  </PageWithPermission>
                }
              />
            </Route>
          </Route>
        </Route>
        <Route path="dsc-register">
          <Route
            index
            element={
              <PageWithPermission name={Permissions.VIEW_DSC_REGISTER}>
                <DscRegister />
              </PageWithPermission>
            }
          />
          <Route path="apply-dsc" element={<ApplyDsc />} />
          <Route path="apply-dsc/add" element={<AddApplyDsc />} />

          {/* <Route path="dsc-register" element={<GstUi />}>
            <Route index element={<DscRegister />} />
            <Route path="gst">
              <Route path="gstr-1" element={<GstHome />} />
              <Route path="gstr-3b" element={<GstHome />} />
              <Route path="gstr-9" element={<GstHome />} />
              <Route path="gstr-9c" element={<GstHome />} />
              <Route path="gstr-08" element={<GstHome />} />
            </Route> */}
          <Route
            path=":dscId"
            element={
              <PageWithPermission name={Permissions.VIEW_DSC_REGISTER}>
                <ClientDscRegisterView />
              </PageWithPermission>
            }
          />
        </Route>
        <Route path="udin-register">
          <Route
            index
            element={
              <PageWithPermission name={Permissions.VIEW_UDIN}>
                <UdinRegister />
              </PageWithPermission>
            }
          />
        </Route>
        {/* ICAI SSP sync; same ICAI logins as UDIN, so UDIN permission for now */}
        <Route
          path="icai-ssp"
          element={
            <PageWithPermission name={Permissions.VIEW_UDIN}>
              <IcaiSspRegister />
            </PageWithPermission>
          }
        />
        <Route
          path="document-in-out"
          element={
            <PageWithPermission name={Permissions.VIEW_DOCUMENT_IN_OUT}>
              <DocumentInOut />
            </PageWithPermission>
          }
        >
          {/* <Route index  /> */}
        </Route>
        <Route
          path="expiry-mgmt"
          element={
            <PageWithPermission name={Permissions.VIEW_EXPIRY_MANAGEMENT}>
              <ExpiryMgmt />
            </PageWithPermission>
          }
        >
          {/* <Route index  /> */}
        </Route>

        <Route path="return-tracker" element={<GstUi />}>
          <Route path="regular" element={<GstRegular />} />
          <Route path="collector" element={<GstCollector />} />
          <Route path="deductor" element={<GstDeductor />} />
        </Route>

      </Route>

      <Route path="/settings" element={<SettingsLayout />}>
        <Route path="communication-preference" element={<CommunicationDetails />}></Route>
        {/* <Route path="task-preference" element={<TaskPreferences />}></Route> */}
        <Route path="org-preferences" element={<OrganizationPreference />} />


        <Route
          path="task-preference"
          element={
            <PageWithPermission name={Permissions.MANAGE_GENERAL_PREFERENCES}>
              <PreferencesLayout />
            </PageWithPermission>
          }
        >
          <Route index element={<TaskPreferences />} />
          <Route path="loghour" element={<LogHourPreferences />} />
          <Route path="approvals" element={<ApprovalPreferences />} />

          {/* <Route index />
            <Route path="preferences"  >
            </Route> */}
        </Route>

        <Route
          path="attendance-preference"
          element={
            <PageWithPermission name={Permissions.MANAGE_ATTENDANCE_PREFERENCES}>
              <AttendancePreferences />
            </PageWithPermission>
          }
        />

        <Route
          path="attendance/admin-log"
          element={
            <PageWithPermission name={Permissions.MANAGE_USER_ATTENDANCE}>
              <AdminLog />
            </PageWithPermission>
          }
        />

        <Route
          path="categories"
          element={
            // <PageWithPermission name={Permissions.VIEW_CATEGORIES}>
            <Cateogries />
            // </PageWithPermission>
          }
        />
        <Route path="lead-document-templates">
          <Route
            index
            element={
              <PageWithPermission name={Permissions.VIEW_DOCUMENT_TEMPLATES}>
                <LeadDocumentTemplates />
              </PageWithPermission>
            }
          />
          <Route
            path="add"
            element={
              <PageWithPermission name={Permissions.CREATE_DOCUMENT_TEMPLATES}>
                <LeadDocumentTemplateEditor />
              </PageWithPermission>
            }
          />
          <Route
            path=":templateId/edit"
            element={
              <PageWithPermission name={Permissions.EDIT_DOCUMENT_TEMPLATES}>
                <LeadDocumentTemplateEditor />
              </PageWithPermission>
            }
          />
          <Route
            path=":templateId/preview"
            element={
              <PageWithPermission name={Permissions.VIEW_DOCUMENT_TEMPLATES}>
                <LeadDocumentTemplatePreview />
              </PageWithPermission>
            }
          />
        </Route>
        {/* <Route path="billing-entities"> */}
        {/* <Route path="settings/billing-entities/create" element={<CreateBillingEntity />} /> */}
        {/* <Route index element={<BillingEntities />} /> */}
        {/* <Route path=":billingEntityId" element={<BillingEntityProfile />} /> */}

        {/* </Route> */}
        <Route path="billing-entities">
          <Route
            index
            element={
              <PageWithPermission name={Permissions.MANAGE_ORG_BILLING_ENTITIES}>
                <BillingEntitiesServiceDescription />
              </PageWithPermission>
            }
          />
          <Route
            path=":billingEntityId"
            element={
              <PageWithPermission name={Permissions.MANAGE_ORG_BILLING_ENTITIES}>
                <BillingEntityProfile />
              </PageWithPermission>
            }
          />
        </Route>
        <Route path="profile" element={<MyProfile />} />
        <Route path="users">
          <Route
            index
            element={
              <PageWithPermission name={Permissions.VIEW_USERS}>
                <Users />
              </PageWithPermission>
            }
          />
          <Route
            path=":userId"
            element={
              <PageWithPermission name={Permissions.VIEW_USERS}>
                <ViewUser />
              </PageWithPermission>
            }
          />
        </Route>
        <Route path="invited-users" element={<InviteUsers />} />
        <Route path="user-availability" element={<UserAvailabilty />} />
        <Route path="storage-management" element={<StorageManagement />} />
        <Route path="completed-tasks" element={<CompletedTasks />} />
        <Route path="deleted-tasks" element={<DeletedTerminatedTasks />} />
        <Route path="deleted-clients-clientgroups" element={<DeletedClientClientGroup />} />
        <Route path="deleted-users" element={<DeletedUsers />} />
        <Route
          path="deleted-leads"
          element={
            <PageWithPermission name={Permissions.VIEW_LEADS}>
              <DeletedLeads />
            </PageWithPermission>
          }
        />
        <Route path="deleted-atom-pro" element={<DeletedPanTanGst />} />
        <Route path="upcoming-tasks" element={<UpcomingTasks />} />
        {/* <Route path='client-preferences' element={<ClientNotificationPreferences />} /> */}

        <Route path="client-preferences" element={<ClientLayout />}>
          <Route
            index
            element={
              <PageWithPermission name={Permissions.MANAGE_CLIENT_PREMISSION}>
                <ClientNotificationPreferences />
              </PageWithPermission>
            }
          />
          <Route path="prefix" element={<ClientPrefix />} />
          <Route
            path="whatsapp-number"
            element={
              <PageWithPermission name={Permissions.MANAGE_CLIENT_PREMISSION}>
                <ClientWhatsappNumber />
              </PageWithPermission>
            }
          />

          {/* <Route index />
            <Route path="preferences"  >
            </Route> */}
        </Route>

        {/* <Route path="atom-pro">
            <Route index element={<Websites />} />
            <Route path="income-tax" element={<AtomPro />}>
              <Route index element={<IncomeTaxDashboard />} />
              <Route path="demands" element={<OutstandingDemand />} /> */}

        {/* <Route path="client-preferences">
            <Route
              index
              element={
                <PageWithPermission name={Permissions.MANAGE_CLIENT_PREMISSION}>
                  <ClientNotificationPreferences />
                </PageWithPermission>
              }
            />
          </Route> */}
        <Route path="notifications-preferences" element={<NotificationsPreferences />} />
        <Route path="preferences">
          <Route
            index
            element={
              <PageWithPermission name={Permissions.MANAGE_NOTIFICATION_PREFERENCES}>
                <NotificationUsers />
              </PageWithPermission>
            }
          />
          <Route
            path=":id"
            element={
              <PageWithPermission name={Permissions.MANAGE_NOTIFICATION_PREFERENCES}>
                <NotificationsSingleUser />
              </PageWithPermission>
            }
          />
        </Route>
        {/* <Route path="preferences" element={<NotificationUsers />} /> */}
        {/* <Route path="preferences/:id" element={<NotificationsSingleUser />} /> */}
        <Route path="teams">
          <Route index element={
            <PageWithPermission name={Permissions.VIEW_TEAMS}>
              <Teams />
            </PageWithPermission>
        } />
          <Route path=":teamId" element={<ViewTeam />} />
        </Route>
        <Route path="labels" element={<Labels />} />
        {/* <Route path="communication/settings/sendNotifications" element={<SendNotifications/>} /> */}
        {/* <Route path ="/settings/sendNotifications/notify" element ={<NotificationNotify/>}/> */}
        <Route path="roles-permissions">
          <Route
            index
            element={
              <PageWithPermission name={Permissions.MANAGE_ORG_ROLES}>
                <Roles />
              </PageWithPermission>
            }
          />
          <Route path=":roleId" element={<EditPermissions />} />
        </Route>
        <Route path="approval-process">
          <Route index element={<ApprovalProcess />} />
          <Route path="approvel-procedure" element={<ApprovalProcedue />} />
          <Route path="approvel-procedure-view" element={<ApprovalProcedueView />} />
        </Route>
        <Route path="approvals" element={<Approvals />} />
        <Route
          path="organization-profile"
          element={
            <PageWithPermission name={Permissions.MANAGE_ORG_PROFILE}>
              <OrganizationProfile />
            </PageWithPermission>
          }
        />
        <Route
          path="onboarding"
          element={
            <PageWithPermission name={Permissions.MANAGE_ORG_PROFILE}>
              <OrganizationOnboarding />
            </PageWithPermission>
          }
        />
        <Route
          path="org-chart"
          element={
            <PageWithPermission name={Permissions.VIEW_ORGANIZATION_CHART}>
              <OrgChart />
            </PageWithPermission>
          }
        />
        <Route
          path="tasks-bulk-activity"
          element={
            <PageWithPermission
              name={Permissions.BULK_ACTIVITY_VIEW}
            >
              <TaskBulkEdit />
            </PageWithPermission>
          }
        />
        <Route path="approvals-bulk-activity" element={<ApprovalBulkActivity />} />
        <Route path="recurring-bulk-activity" element={
          <PageWithPermission
            name={Permissions.BULK_ACTIVITY_VIEW}
          >
            <RecurringProfileBulkActivity />
          </PageWithPermission>
        }
        />
        <Route path="non-recurring-bulk-activity" element={
          <PageWithPermission
            name={Permissions.BULK_ACTIVITY_VIEW}
          >
            <NonRecurringBulkEdit />
          </PageWithPermission>
        }
        />
        <Route path="attendance-bulk-activity" element={<AttendanceBulkActivity />} />
      </Route>

      <Route path="/forms/builder/:formId" element={<FormBuilder />} />
      <Route path="/forms/access/:formId" element={<AccessForm />} />
      <Route path="/tasks/:taskId/iPro/:formId" element={<ViewIproForm />}>
        <Route path="view" element={<ViewIproFormEntry />} />
        <Route path="edit" element={<FormBuilder />} />
        <Route path="audit-log" element={<IProAuditLog />} />
      </Route>
      <Route path="/clients/:clientId/kyb-info/:formId" element={<ViewKyb />}>
        <Route path="view" element={<ViewIproFormEntry />} />
        <Route path="edit" element={<FormBuilder />} />
        <Route path="fill-details" element={<AccessForm withoutAppbar />} />
        <Route path="audit-log" element={<IProAuditLog />} />
      </Route>
      <Route path="/billing/invoices/:invoiceId/preview" element={<InvoicePreview />} />
      <Route path="/billing/credit-note/:creditNoteId/preview" element={<CreditNotePreview />} />
      <Route path="/billing/proforma/:proformaId/preview" element={<ProformaPreview />} />
      <Route path="/billing/receipts/:receiptId/preview" element={<ReceiptPreview />} />

      <Route path="/forms/:formId/fields/:fieldId/esign" element={<Esign />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/login" element={<Login />} />
      <Route path="/authentication" element={<MfaAuthentication />} />
      <Route path="/sso" element={<SsoLanding />} />
      <Route path="/forgot-password-otp" element={<OtpForgot />} />

      <Route path="/collect-data/:collectId" element={<CollectData />} />
      <Route path="/lead-portal/:token" element={<LeadPortal />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/join" element={<Join />} />
      <Route path="/onedrive-auth" element={<OnedriveAuth />} />
      <Route path="/onedrive-auth-signup" element={<OnedriveAuthSignup />} />
      <Route path="/googledrive-auth-signup" element={<GoogledriveAuthSignup />} />
      <Route path="/googledrive-auth" element={<GoogledriveAuth />} />
      <Route path="/zoho-auth" element={<ZohoBooksAuth />} />
      <Route path="/signup-onedrive" element={<OnedriveConnection />} />
      <Route path="/signup-google" element={<GoogledriveConnection />} />
      <Route path="/signup-bharathcloud" element={<BharathCloudConnection />} />
      <Route path="subscription">
        <Route index element={<Subscription />} />
      </Route>

    </Routes>
    // </Router>
  );
}

export default RoutesContainer;
